import { Component, inject } from '@angular/core';
import { IconsService } from '../../../services/icons.service';

@Component({
  selector: 'app-footer-krismar',
  imports: [],
  templateUrl: './footer-krismar.component.html',
  styleUrl: './footer-krismar.component.css'
})
export class FooterKrismarComponent {
        public _icon = inject(IconsService);

}
